// extracted by mini-css-extract-plugin
export default {"root":"PendingCallLabel_root__npPjG"};